const ZERO_WIDTH_JOINER = 0x200d;
const INVISIBLE = /\p{Cf}/u;
const BLANK = /\p{White_Space}/u;
const MARK = /[\p{Mn}\p{Me}]/u;

const isSkinTone = (cp: number) => cp >= 0x1f3fb && cp <= 0x1f3ff;
const isRegionalIndicator = (cp: number) => cp >= 0x1f1e6 && cp <= 0x1f1ff;

export const visibleLength = (text: string | null | undefined): number => {
  const chars = Array.from(text ?? "");
  const shown = (c: string) => !BLANK.test(c) && !INVISIBLE.test(c);
  const first = chars.findIndex(shown);
  if (first < 0) return 0;
  const last = chars.length - 1 - [...chars].reverse().findIndex(shown);

  let count = 0;
  let joinsPrevious = false;
  let halfFlag = false;
  for (const c of chars.slice(first, last + 1)) {
    const cp = c.codePointAt(0) ?? 0;
    if (cp === ZERO_WIDTH_JOINER) joinsPrevious = true;
    else if (INVISIBLE.test(c) || MARK.test(c) || isSkinTone(cp)) continue;
    else if (joinsPrevious) joinsPrevious = false;
    else if (isRegionalIndicator(cp)) {
      if (!halfFlag) count++;
      halfFlag = !halfFlag;
    } else {
      halfFlag = false;
      count++;
    }
  }
  return count;
};
